var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEnvironments = function SvgEnvironments(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    d: "M20.1,1v38 M1,20h37.9 M3.4,10.7h33.2 M3.5,29.4h33.1 M19.9,1c0,0-10.2,4.6-10.2,19.1S19.9,39,19.9,39 M20.4,39 c0,0,10.2-4.6,10.2-19.1S20.4,1,20.4,1 M20,1C9.5,1,1,9.5,1,20s8.5,19,19,19s19-8.5,19-19S30.5,1,20,1z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEnvironments);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/environments.d661b166e1a262dc8e2a7c6cd48beeca.svg";